import subscribers from "../../assets/icons/subs.svg";
import online from "../../assets/icons/login.svg";
import name from "../../assets/icons/subreddit.svg";
import description from "../../assets/icons/info.svg";
import "./StatCard.scss";
import classnames from "classnames";

const StatCard = ({ info, title, type }) => {
  let image;
  if (type === "subredditPulse") {
    image = online;
  } else if (type === "subscribers") {
    image = subscribers;
  } else if (type === "name") {
    image = name;
  } else if (type === "description") {
    image = description;
  }

  const getActivityColor = (label) => {
    if (label === "Highly Active") {
      return "#2ED573";
    } else if (label === "Active") {
      return "#4DA3FF";
    }
      else if (label === "Moderate") {
        return "#FFC94A";
    } else if (label === "Inactive") {
      return "#9AA4B2";
    } else {
      return undefined;
    }
  };

  return (
    <article
      className={`statCard ${
        type === "online"
          ? "statCard__online"
          : type === "description"
          ? "statCard__description"
          : ""
      }`}
    >
      <img src={image} alt="" className="statCard__icon" />
      <div className="statCard__container">
        <div className="statCard__circle-container">
        {type === "subredditPulse" && (
          <span className="statCard__circle" style={{ backgroundColor: getActivityColor(info) }}/>
        )}
        <p
          className={
            classnames(
              type === "description" ? "statCard__text" : "statCard__info",
            )
          }
        >
          {type !== "description"
            ? info
            : info.length === 0
            ? `This subreddit does not provide a ${type}.`
            : info}
        </p>
        </div>
        <h3 className={`statCard__title`}>{title}</h3>
      </div>
    </article>
  );
};

export default StatCard;
